import { NoddiInfoBanner } from 'noddi-ui-web';

import { errorCodesEnglish } from 'noddi-util';

export const OutsideServiceAreaInfo = () => (
  <NoddiInfoBanner
    variant='info'
    title='Outside service area'
    texts={[{ value: errorCodesEnglish.service_department_not_found_api_error }]}
  />
);
